<template>
    <div class="modal" tabindex="-1" id="resubmissionDate">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1>{{ $trans.get('__JSON__.Set resubmission date') }}</h1>
                </div>
                <div class="modal-body">
                    <div v-if="errors" class="alert alert-danger" role="alert">
                        <p v-for="error in errors">
                            {{ $trans.get("__JSON__." + error) }}
                        </p>
                    </div>
                    <div class="mb-3 col-6">
                        <label for="resubmission_date">{{ $trans.get("__JSON__.Resubmission date") }}</label>
                        <input type="date" v-model="resubmissionDate" class="form-control" id="resubmission_date" />
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger" @click="closeModal">{{
                        $trans.get('__JSON__.Cancel') }}</button>
                    <button class="btn btn-secondary" @click="updateResubmisisonDate">{{
                        $trans.get('__JSON__.Save') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { DateTime } from "luxon";
import { watch } from "vue";

export default {
    name: "ResubmissionDate",
    props: {
        oimAppointment_id: Number,
        resubmissionDateProp: String,
    },
    emits: ['saved', 'abort'],
    data() {
        return {
            resubmissionDate: this.resubmissionDateProp,
            errors: null,
        };
    },
    watch: {
        resubmissionDateProp: {
            handler(newValue, oldValue) {
                if(newValue !== null) {
                    this.resubmissionDate = DateTime.fromFormat(newValue, 'yyyy-MM-dd HH:mm:ss').toISODate();
                }
                else{
                    this.resubmissionDate = null;
                }
            },
            deep: true,
        },
    },
    methods: {
        updateResubmisisonDate() {
            axios
                .put("/api/oimappointments/" + this.oimAppointment_id, {
                    params: {
                        resubmissionDate: this.resubmissionDate,
                    }
                })
                .then((resp) => {
                    this.$emit('saved');
                    this.resubmissionDate = null;
                    $('#resubmissionModal').modal('hide');
                })
                .catch((error) => {
                    this.errors = error.response.data;
                });
        },
        closeModal() {
            this.$emit('abort');
            $('#resubmissionModal').modal('hide');
        }
    }
}

</script>